module.exports = __webpack_public_path__ + "img/my-kaipiao.a09b52b5.png";